export const AUTH_TOKEN_STORAGE_NAME = 'tHashToken';
